<template>
  <div>
    <div class="mt-1">
      <p class="text-start ms-4 text-secondary">
        Listado de Usuarios
      </p>

      <div class="col-12 d-flex justify-content-end mt-0">
        <div class="input-group buscar-estiloCuadrado" style="max-width: 350px;">
          <span class="input-group-text buscar-estiloCuadrado">
            <i class="bi bi-search"></i>
          </span>
          <input class="form-control buscar-estiloCuadrado" type="text" placeholder="Buscar usuario o nombre"
            v-model="busqueda" @input="Filtro" />
        </div>
      </div>


      <div class="table-responsive mx-2 mt-2 py-3">
        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th>ID</th>
              <th>APELLIDOS Y NOMBRES</th>
              <th>USUARIO</th>
              <th>CREACIÓN</th>
              <th>ACTUALIZACIÓN</th>
              <th><i class="bi bi-boxes fs-5"></i></th>
            </tr>
          </thead>

          <tbody class="text-nowrap text-center texto-fini align-middle">


            <tr v-if="loading">
              <td colspan="7" class="text-center" style="height: 220px;">
                <div class="d-flex flex-column align-items-center justify-content-center h-100">
                  <div class="spinner-border text-warning" style="width: 3rem; height: 3rem;"></div>
                  <div class="mt-3 text-secondary fw-semibold fs-6">
                    Filtrando información...
                  </div>
                </div>
              </td>
            </tr>


            <tr v-else v-for="lista in paginatedLista" :key="lista.idUsuario" class="reducirTamaño">
              <td>{{ lista.idUsuario }}</td>
              <td class="text-start">{{ lista.usuNombres }}</td>
              <td>{{ lista.usuCodigo }}</td>
              <td>{{ lista.audfecCreacion }}</td>
              <td>{{ lista.audfecActualizacion }}</td>

              <td>
                <button @click="openEditModal(lista.idPerfil, lista.perNombre, lista)"
                  class="btn btn-warning mx-1 py-0 px-2">
                  <i class="bi bi-pencil text-white fs-5"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">

        <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <span class="pagination-info small">
          Página {{ currentPage }} de {{ totalPages }}
        </span>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
          :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>

      </div>


      <b-modal ref="editModal" centered hide-footer hide-close-button dialog-class="modal-md">
  <template #modal-title>
    <div class="d-flex align-items-center gap-2">
      <i class="bi bi-person-gear fs-4 text-primary"></i>
      <span class="fw-semibold">Editar Acceso</span>
    </div>
  </template>

  <div class="container-fluid">

   
    <div class="mb-3">
      <label class="form-label fw-semibold">SELECCIONAR PERFIL:</label>

      <div class="input-group">
        <span class="input-group-text bg-light">
          <i class="bi bi-person-badge"></i>
        </span>

        <select class="form-select" v-model="idPerfil">
          <option value="" disabled>--SELECCIONAR PERFIL--</option>
          <option v-for="item in ListaPerfil" :key="item.idPerfil" :value="item.idPerfil">
            {{ item.perNombre }}
          </option>
        </select>
      </div>
    </div>

  
    <div class="d-flex justify-content-end mt-4 gap-2">

      <b-button variant="success" class="px-4" @click="saveChanges">
        <i class="bi bi-check-circle "></i> 
      </b-button>

      <b-button variant="outline-secondary" class="px-4" @click="closeEditModal">
        <i class="bi bi-x-lg "></i>
      </b-button>

    </div>

  </div>
</b-modal>

    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert";

export default {
  name: "PowerbyTablaUsuario",

  data() {
    return {
      busqueda: "",
      loading: false,
      currentPage: 1,
      itemsPerPage: 10,

      idPerfil: "",
      nombrePerfil: "",
      listaUsuarios: [],
      idUsuario: "",
      idUsuarioUnico: "",

    };
  },

  computed: {
    ...mapGetters("acciones", ["ListaPerfil", "ListaUsuarios"]),


    filteredList() {
      const filtro = (this.busqueda || "").toLowerCase().trim();
      if (!filtro) return this.ListaUsuarios;

      return this.ListaUsuarios.filter(item =>
        item.usuNombres.toLowerCase().includes(filtro) ||
        item.usuCodigo.toLowerCase().includes(filtro)
      );
    },


    totalPages() {
      return Math.ceil(this.filteredList.length / this.itemsPerPage);
    },


    paginatedLista() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredList.slice(start, start + this.itemsPerPage);
    }
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
  },
  created() {
  },

  methods: {

    Cambiar(idperfil) {
      this.axios
        .put(`BIClientes/ModificarEstadoAcceso?idUsuario=${idperfil}`)
        .then((r) => {
          console.log(r.data);
        });
    },

    openEditModal(idPerfil, nombre, id) {
      this.idPerfil = idPerfil;
      this.nombrePerfil = nombre;
      this.idUsuarioUnico = id.idUsuario;
      console.log(id);
      this.$refs.editModal.show();
    },

    closeEditModal() {
      this.idPerfil = "";
      this.nombrePerfil = "";
      this.$refs.editModal.hide();
    },

    saveChanges() {
      // Aquí puedes guardar el nombre editado y realizar otras operaciones necesarias
      // Luego, cierra el modal
      const from = {
        idUsuario: this.idUsuarioUnico,
        idPerfil: this.idPerfil,
        idUsuCreacion: this.idUsuario,
      };

      console.log(from);
      this.axios.put(`BIClientes/ModificarAcceso`, from).then((r) => {
        console.log(r.data);

        Swal(`Se realizo los cambios`, "", "success");
        this.closeEditModal();
      });
    },
    Filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 800);
    },
  },
};
</script>

<style scoped>
.b-modal .modal-header button.close {
  display: none;
}

.bg-solimano {
  text-align: center;
  background: #0080c8;
}

strong {
  font-size: 1.64rem;
  color: black;
}

.letra {
  font-weight: 600;
}

/* .icon-selector {
  display: flex;
  gap: 10px;
} */
.bg-iconos {
  background: #f7f7f7;
}

.icon-selector div {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 2px;
}

.icon-selector div.selected {
  border-color: #007bff;
  /* Color de borde al seleccionar */
}

.icon-selector i {
  font-size: 24px;
  /* Tamaño de los iconos */
}

.tamañoLetra {
  font-size: 0.8rem;
}

.reducirTamaño {
  font-size: 0.65rem;
}
</style>
